import React, {useEffect, useState} from "react";

interface ConfirmationAreaProps {
  listOfConfirmations: string[];
  isSubmittingChange: boolean;
  enableSaving: boolean;
  textToShow?: string;
}

export default function ConfirmationArea({
                                           listOfConfirmations,
                                           isSubmittingChange,
                                           enableSaving,
                                           textToShow,
                                         }: ConfirmationAreaProps) {
  const [confirmationCount, setConfirmationCount] = useState<number>(0);

  useEffect(() => {
    // reset the selected count of checkboxes ticked when we update list of confirmations
    setConfirmationCount(0);
  }, [listOfConfirmations]);

  return <div id="formConfirmationArea" className="form-confirmation-area">
    {textToShow && (
        <h5>{textToShow}</h5>
    )}
    {listOfConfirmations.map((confirmation, index) => (
        <div id={`formConfirmation${index}`} className="form-check">
          <input id={`formConfirmation${index}Check`} className="form-check-input" type="checkbox"
                 value=""
                 // unique key needed otherwise first checkbox will retain its previous checked state when updating confirmations
                 key={`${confirmation}-${index}`}
                 onChange={(event) => {
                   event.target.checked ?
                       setConfirmationCount(confirmationCount + 1) :
                       setConfirmationCount(confirmationCount - 1)
                 }}/>
          <label id={`formConfirmation${index}Label`} className="form-check-label"
                 htmlFor={`formConfirmation${index}Check`}>
            {confirmation}
          </label>
        </div>
    ))}
    <div id="formSaveArea" className="form-save-area">
      <button id="formSubmitBtn" type="submit" className="btn btn-success"
              formNoValidate
              disabled={confirmationCount !== listOfConfirmations.length || isSubmittingChange}
      >Submit
      </button>
      {enableSaving && (
          <button id="formSaveBtn" type="submit" className="btn btn-success"
                  formNoValidate
                  disabled={isSubmittingChange}
          >Save
          </button>
      )}
    </div>
  </div>;
}